import React, { useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import Styles from "../../Views/Operations/BusinessDescription/BusinessDescription.module.css";
import CardImg from "../.././assets/images/activity_cardimg.png"
import ActivityStyle from "./activity.module.css"
import { sections, sectionPaths } from "../.../../../constants/sectionData";

import {
    Box,
    Paper,
    Typography,
  
  } from "@mui/material";
import SectionSlider from "../Reusable/SectionSlider/SectionSlider";

const ActivityBible: React.FC = () => {
    const [activeSection, setActiveSection] = useState(3);
    const management = localStorage.getItem("management") || "Default Location Name";

  
    const handleNextSection = () => {
        setActiveSection((prev) => (prev + 1) % sections.length);
      };
    
    const handlePrevSection = () => {
        setActiveSection((prev) => (prev - 1 + sections.length) % sections.length);
      };

    const breadcrumbs = [
         <Link key="1" color="#000" to="/">
              Home
            </Link>,
            <Link key="2" color="#000" to="/operations/management">
              Evidence Upload
            </Link>,
            <Link key="3" color="#000" to="/operations/management">
              Management
            </Link>,
        <Typography key="4">{management}</Typography>,
      ];
    
    return(
        <>
     <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Activity Bible"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />


      <Box className={ActivityStyle.biblecard} sx={{ maxWidth: 350, m:2 }}>
      <Box className={ActivityStyle.cardImgcontent}>
       <img className={ActivityStyle.cardimg} src={CardImg} />
       <Box  className={ActivityStyle.Imgtext}>
       <h3>Activity Bible</h3>
       </Box>
       </Box>
        <Box>
          <Typography gutterBottom variant="h5" component="div">
            <button className={ActivityStyle.biblecardbutton}>Coming Soon</button>
          </Typography>
         
        </Box>
      </Box>
    



        </>
    )
}
    
    export default ActivityBible;
